import type { ReactNode } from 'react'
import React from 'react'

export class Wrapper extends React.Component<
  {
    children?: ReactNode
  },
  {}
> {
  element: Element | null = null
  childRef = React.createRef<HTMLElement>();
  wrapperRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    this.componentDidUpdate()
  }

  componentDidUpdate() {
    // 优先获取子元素的 ref
    let node = this.childRef.current;
    // 如果子元素的 ref 获取失败，则获取包装器的第一个子元素
    if (!node && this.wrapperRef.current) {
      node = this.wrapperRef.current.firstElementChild as HTMLElement;
    }

    if (node instanceof Element) {
      this.element = node
    } else {
      this.element = null
    }
  }

  render() {
    const child = React.Children.only(this.props.children)

    // 使用包装器 div，但保持子元素的直接引用
    return (
      <div ref={this.wrapperRef} style={{ display: 'contents' }}>
        {child}
      </div>
    )
  }
}
